export default __webpack_public_path__ + "static/media/pantry2-before1-1920w.155ffb38.avif";